import React, { JSX } from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { sanitize } from '@ibe/services';
import { ApiCarRate, ApiRentalCar } from '@ibe/api';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';

import SummaryTabs from '../Base/SummaryTabs';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import Dates from '../Dates';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    showNumberOfPerson,
    item,
    isOpen,
    showInfo,
    showTraveler,
    showSsr,
    booking,
    onDelete,
    customPriceModifier,
    order
  } = props;
  const { t } = useTranslation('summary', fallback, Keys);
  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';
  const carRate: ApiCarRate | undefined = booking.items.find(
    bookingItem => item.idParent === bookingItem.id
  ) as ApiCarRate;
  const rentalCar: ApiRentalCar | undefined = booking.items.find(
    bookingItem => carRate?.idParent === bookingItem.id
  );

  const InfoTabContent = (): JSX.Element => {
    return (
      <>
        {rentalCar && rentalCar.supplier && <div>{rentalCar.supplier.description}</div>}
        <div dangerouslySetInnerHTML={{ __html: sanitize(item.name) }} />
        <br />
        {rentalCar && (
          <div>
            {rentalCar.pickupStation?.description},{' '}
            <DateDisplay date={rentalCar.pickupDate || ''} /> {rentalCar.pickupTime} -{' '}
            {rentalCar.dropoffStation?.description},{' '}
            <DateDisplay date={rentalCar.dropoffDate || ''} /> {rentalCar.dropoffTime}
          </div>
        )}
      </>
    );
  };

  const customPrice = customPriceModifier && customPriceModifier(item);
  return (
    <SummaryItem
      title={item.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={item.description}
      icon={<Icon icon={faCar} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      order={order?.RentalCar}
      numberOfPerson={numberOfPersonLabel}
    >
      {(showInfo || showTraveler || showSsr) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoTabContent />}
          showInfo={showInfo}
          showTraveler={showTraveler}
          showSsr={showSsr}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
